/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Fragment } from 'react';

import { RECORD_TYPES } from '~/legacy/utils';

import ArticleSearchResult from './ArticleSearchResult';
import ProductSearchResult from './ProductSearchResult';

const SearchResult = ({ hit, hit: { type }, ...props }: any) =>
  type === RECORD_TYPES.PRODUCT ? (
    <ProductSearchResult hit={hit} {...props} />
  ) : type === RECORD_TYPES.ARTICLE ? (
    <ArticleSearchResult hit={hit} {...props} />
  ) : (
    <Fragment />
  );

export default SearchResult;
